import { IServiceClient } from 'src/interfaces/serviceClient';

/**
 * Builds a single display label for the vehicles in a service client row.
 * Uses lead.service.vehicles[].vehicle (make name + model); returns null if none.
 *
 * @param row - Service client (lead with type service and optional service.vehicles)
 * @returns Comma-separated vehicle labels (e.g. "MakeA Model1, MakeB Model2") or null
 */
export function getVehicleLabel(row: IServiceClient): string | null {
    const serviceVehicles = row.service?.vehicles;
    if (Array.isArray(serviceVehicles) && serviceVehicles.length > 0) {
        return serviceVehicles
            .map((item) => {
                const vehicle = item?.vehicle;
                if (!vehicle) return '';
                const makeName = vehicle.make?.name ?? '';
                const model = vehicle.model ?? '';
                return [makeName, model].filter(Boolean).join(' ');
            })
            .filter(Boolean)
            .join(', ');
    }
    return null;
}
